import { render, staticRenderFns } from "./ListMedthese.vue?vue&type=template&id=843501e2&"
import script from "./ListMedthese.vue?vue&type=script&lang=js&"
export * from "./ListMedthese.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports